export const math = {
  normalize: (value, max, min) => (value - min) / (max - min),
  denormalize: (value, start, end) => value * (end - start) + start,
  lerp: (previous, current, ease) => (1 - ease) * previous + ease * current,
  clamp: (min, max, value) => Math.max(min, Math.min(value, max))
}